import styled from 'styled-components';
import { Button, Col, Input, Row, Typography } from 'antd';

const { Title } = Typography;

export const Wrapper = styled.div`
  label {
    color: #707070;
  }
  .ant-input.ant-input-lg {
    background: #f2f2f2;
  }
  .ant-input-affix-wrapper.ant-input-affix-wrapper-lg.ant-input-password.ant-input-password-large {
    background: #f2f2f2;
    border: none;
  }
  padding: 0 18px 8px 16px;
`;
export const BlocoStyled = styled.div`
  margin-top: 14px;
  background: #fff;
  padding: 11px 24px;
  border-radius: 2px;
`;

export const TitleBloco = styled(Title)`
  margin: 0 !important;
`;

export const ButtonVoltar = styled(Button)`
  border-radius: 2px;
  background: #24a95d;
  border: none;
  outline: none;
  font-weight: bold;
  width: 117px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  &:hover {
    background: #24a95d;
    color: #fff;
  }
  &:focus {
    background: #24a95d;
    color: #fff;
  }
`;

export const Columns = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: center;
`;

export const ColStyled = styled(Col)`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
`;

export const RowStyled = styled(Row)`
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  height: 750px;
  width: 100%;
  min-width: 0;
  border-radius: 2px;
  padding-top: 18px;
  background: #fff;
`;

export const InputStyled = styled(Input)`
  background: #f2f2f2 !important;
  border-radius: 2px;
  border: none;
  min-width: 0;
  &:focus {
    background: #f2f2f2;
  }
  &:hover {
    background: #f2f2f2;
  }
`;
export const StyledButton = styled(Button)`
  width: 116px;
  height: 40px;
  color: #fff;
  border-radius: 2px;
  background: #24a95d;
  border: none;
  outline: none;
  font-weight: bold;
  &:hover {
    background: #24a95d;
    color: #fff;
    transform: scale(1.05);
  }
  &:focus {
    background: #24a95d;
    color: #fff;
  }
`;
export const AvatarDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  > h1 {
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    color: #24a95d;
  }
  > p {
    font-size: 14px;
    line-height: 16px;
    text-align: center;
    color: #24a95d;
    font-weight: bold;
    margin: 14px 0;
  }
`;

export const TitleSection = styled.div`
  padding: 8px 5% 16px 5%;
  width: 100%;
  > p {
    font-weight: bold;
    font-size: 16px;
    line-height: 19px;
    text-align: start;
    color: #707070;
    margin: 8px 0;
  }
`;
